/* ============================================================
   ATHLO+ — Hub Rewards launcher
   Drives the brand-native rewards launcher + slide-in panel
   (snippets/hub-rewards.liquid). The member's real Reward-Points
   balance + tier are filled by assets/hub-loyalty.js (our own
   Supabase loyalty backend) — no third-party widget.
   (Smile.io bridge removed 2026-07-24: points are now unified on
   the loyalty backend, so the panel shows one balance, not two.)
   Inert-safe: no-ops if the markup isn't present.
   ============================================================ */
(function () {
  'use strict';

  var launch = document.getElementById('hr-launch');
  var panel  = document.getElementById('hr-panel');
  var scrim  = document.getElementById('hr-scrim');
  var closeB = document.getElementById('hr-close');
  if (!launch || !panel || !scrim) return;

  var open = false;

  function openPanel() {
    if (open) return;
    open = true;
    panel.hidden = false; scrim.hidden = false;
    // next frame so the transition runs
    requestAnimationFrame(function () { panel.classList.add('is-open'); scrim.classList.add('is-open'); });
    launch.setAttribute('aria-expanded', 'true');
    document.documentElement.classList.add('lenis-stopped');
    document.body.style.overflow = 'hidden';
  }

  function closePanel() {
    if (!open) return;
    open = false;
    panel.classList.remove('is-open'); scrim.classList.remove('is-open');
    launch.setAttribute('aria-expanded', 'false');
    document.documentElement.classList.remove('lenis-stopped');
    document.body.style.overflow = '';
    setTimeout(function () { if (!open) { panel.hidden = true; scrim.hidden = true; } }, 400);
  }

  launch.addEventListener('click', function () { open ? closePanel() : openPanel(); });
  if (closeB) closeB.addEventListener('click', closePanel);
  scrim.addEventListener('click', closePanel);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && open) closePanel(); });
})();
